<template>
  <v-container>
    <v-snackbar v-model="showsnackbar" color="green" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ snackmessage }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
        
      </v-layout>
    </v-snackbar>
    <v-form ref="form" v-model="valid" lazy-validation class="fontts">
      <v-layout wrap>
        <v-flex xs12 md8 py-6 align-self-start class="headings">
          Observational Report
        </v-flex>
      </v-layout>

      <v-layout wrap>
        <v-flex xs12 sm12 md3 align-self-center class="labels">
          Date of observation:
        </v-flex>
        <v-flex xs12 sm12 md9 align-self-center>
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                background-color="#b8e6e5"
                v-model="date"
                solo
                label="Picker without buttons"
                prepend-inner-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              @input="menu2 = false"
              @change="checkDate"
            ></v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>

      <v-layout wrap>
        <v-flex xs12 md3 align-self-center class="labels"> Species: </v-flex>
        <v-flex xs12 md9 align-self-center>
          <v-select
            background-color="#b8e6e5"
            solo
            v-model="species"
            :items="speciesList"
            item-value="_id"
            item-text="name"
            :rules="rules"
          ></v-select>
        </v-flex>
      </v-layout>

      <v-layout wrap>
        <v-flex xs12 md3 align-self-center class="labels"> Type: </v-flex>
        <v-flex xs12 md9 align-self-center>
          <v-select
            background-color="#b8e6e5"
            solo
            v-model="type"
            :items="Types"
            :rules="rules"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout wrap> </v-layout>

      <v-layout wrap>
        <v-flex xs12 md3 lg3 align-self-center class="labels">
          Condition:
        </v-flex>
        <v-flex xs12 md9 lg9 align-self-center text-left>
          <v-select
            background-color="#b8e6e5"
            solo
            v-model="Health_status"
            :items="Conditions"
            :rules="rules"
          ></v-select>
        </v-flex>
      </v-layout>

      <v-layout wrap> </v-layout>

      <v-layout wrap>
        <v-flex xs12 md3 align-self-center class="labels"> Life stage: </v-flex>
        <v-flex xs12 md9 align-self-center>
          <v-select
            background-color="#b8e6e5"
            solo
            v-model="life_stage"
            :items="Life_stagess"
            :rules="rules"
            @click="lStage"
          ></v-select>
        </v-flex>
      </v-layout>

      <v-layout wrap>
        <v-flex></v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 md3 align-self-center class="labels">
          No of individuals/eggs:
        </v-flex>
        <v-flex xs12 md9 align-self-center>
          <v-text-field
            background-color="#b8e6e5"
            :rules="numberRules"
            type="number"
            v-model="no_of_individuals"
            label=""
            solo
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout wrap>
        <v-flex xs12 md3 align-self-center class="labels">
          Habitat found in:
        </v-flex>
        <v-flex xs12 md9 align-self-center>
          <v-select
            background-color="#b8e6e5"
            :items="Habitat_vals"
            style="color: black"
            v-model="habitat_found"
            label=""
            solo
            :rules="rules"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 md3 align-self-center class="labels"> Threats: </v-flex>
        <v-flex xs12 md9 align-self-center>
          <v-select
            background-color="#b8e6e5"
            :items="threds"
            v-model="Threats"
            label=""
            solo
            :rules="rules"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout wrap v-if="Health_status == 'Live'">
        <v-flex xs12 md3 align-self-center class="labels">
          Behaviour observed:
        </v-flex>
        <v-flex xs12 md9 align-self-center>
          <v-select
            background-color="#b8e6e5"
            :items="behaviour"
            v-model="behaviour_observed"
            label=""
            solo
            @click="behaviourData"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 md3 align-self-center class="labels"> State: </v-flex>
        <v-flex xs12 md9 align-self-center>
          <v-select
            :rules="rules"
            background-color="#b8e6e5"
            v-model="state"
            label=""
            solo
            :items="states"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 md3 align-self-center class="labels">
          City/Town/Village:
        </v-flex>
        <v-flex xs12 md9 lg9 align-self-center>
          <v-text-field
            background-color="#b8e6e5"
            :rules="rules"
            v-model="city"
            label=""
            solo
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 md3 align-self-center class="labels"> Comment: </v-flex>
        <v-flex xs12 md9 align-self-center>
          <v-textarea
            background-color="#b8e6e5"
            color="black"
            v-model="comment"
            auto-grow
            rows="4"
            row-height="30"
            solo-inverted
            :rules="rules"
          ></v-textarea>
        </v-flex>
      </v-layout>

      <v-layout wrap>
        <v-flex md12 class="labels"> Upload Images:</v-flex>
      </v-layout>
      <v-layout wrap justify-center>
        <v-flex align-self-center xs4 md3 lg2 px-5 py-8>
          <!-- <v-img  :src="image">
            <v-layout wrap justify-end>
              <v-flex xs2 align-self-end text-right>
                <v-icon color="red" @click="removeImageArray()"
                  >mdi-close-circle</v-icon
                >
              </v-flex>
            </v-layout>
          </v-img> -->

          <!-- <div v-else class="whole-cropper">
                  <div class="cropper-img">
                    <img id="imagefondo" :src="image" ref="imgg" />
                  </div>
                  <div class="cropped-img">
                    <img v-if="destination" :src="destination" />
                  </div>
                </div> -->

          <input
            ref="files"
            type="file"
            :multiple="false"
            style="display: none"
            id="fileUpload"
            accept="image/*"
            @change="browseImages"
          />
          <v-img
            v-if="!image"
            src="../../assets/upload.png"
            contain
            @click="$refs.files.click()"
          ></v-img>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center v-if="yesimg == true">
        <v-flex lg4 align-self-center text-center class="whole-cropper">
          <div v-if="yesuploadedimg == false" class="cropper-img">
            <img id="imagefondo" :src="image" ref="imgg" />
          </div>
          <img
            class="preview-cropped"
            v-if="yesuploadedimg == true"
            :src="destination"
          />
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center v-if="yesimg == true">
        <v-flex
          pt-lg-1
          v-if="yesuploadedimg == false"
          lg1
          align-self-center
          text-center
        >
          <v-btn
            :loading="loading4"
            color="green"
            width="95px"
            @click="uploadCroppedImg"
          >
            Crop
            <template v-slot:loader>
              <span class="custom-loader">
                <v-icon color="red" light>mdi-cached</v-icon>
              </span>
            </template>
          </v-btn>
        </v-flex>
        <v-flex pt-lg-1 lg1 align-self-center text-center>
          <v-btn color="orange" width="95px" @click="removeImageArray()">
            Cancel
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex md12 py-3 class="labels"> Location:</v-flex>
      </v-layout>
      <v-layout wrap justify-center>
        <v-flex py-8 align-self-center>
          <div id="mapnew3"></div>
          <!-- <GmapMap
            :center="{ lat: 10.850516, lng: 76.27108 }"
            :zoom="6"
            map-type-id="terrain"
            style="width: 100%; height: 300px"
            @click="mark"
          >
            <GmapInfoWindow
              @closeclick="window_open = false"
              :opened="window_open"
              :position="infowindow"
              :options="{
                pixelOffset: {
                  width: 0,
                  height: -35,
                },
              }"
            >
              Hello world!
            </GmapInfoWindow>
            <GmapMarker
              :position="{ lat: latt, lng: lonn }"
              :clickable="true"
              :draggable="false"
            />
          </GmapMap> -->
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center text-center>
        <v-flex md1>
          <v-btn large color="#7CBB3E" dark @click="submitData"> Submit </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

 <script
    src="https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyCaccNxbzwR9tMvkppT7bT7zNKjChc_yAw&libraries=visualization,drawing">
</script>

<script>
import Cropper from "cropperjs";
import axios from "axios";
export default {
  data() {
    return {
      showsnackbar: false,
      snackmessage: [],
      loader: null,
      dialog: true,
      yesimg: false,
      yesuploadedimg: false,
      loading4: false,
      cropper: {},
      cimage: {},
      imgUrl: "",
      destination: {},
      myblobb: {},
      state: "",
      city: "",
      type: "",
      species: "",
      no_of_individuals: "",
      life_stage: "",
      Health_status: "",
      habitat_found: "",
      Threats: "",
      behaviour_observed: "",
      presence_of_nest: "",
      comment: "",
      date: new Date().toISOString().substr(0, 10),
      date1: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      latt: 0,
      lonn: 0,
      valid: true,
      UPimages: [],
      image: null,
      imageArray: [],
      Images: new FormData(),
      formData: new FormData(),
      selectedFiles: null,
      speciesList: [],
      Life_stagess: [],
      Conditions: ["Live", "Dead"],
      Habitat_vals: [
        "River",
        "Lake",
        "Pond",
        "Stream",
        "Wetland",
        "Forest",
        "Hills",
        "Canals",
        "Agricultural Field",
        "Reservoir",
        "GrassLand",
        "Deset",
        "Estuary",
        "Marine",
      ],
      threds: [
        "Fishing",
        "Sandmining",
        "Poaching",
        "Infrastructure devolepment",
        "Pollution",
        "Oli spoil",
      ],
      behaviour: [],
      Types: [
        "Wild",
        "Zoo",
        "Commercial market",
        "Personal holding",
        "Religious shrines/community ponds",
      ],
      states: [
        "Andhra Pradesh",
        "Arunachal Pradesh ",
        "Assam",
        "Bihar",
        "Chhattisgarh",
        "Haryana",
        "Himachal Pradesh",
        "Jammu and Kashmir",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Madya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "UttaraKhand",
        "West Bengal",
      ],
      numberRules: [
        (v) => v.length > 0 || "This field may not be empty",
        (v) =>
          Number.isInteger(Number(v)) || "The value must be an integer number",
        (v) => v > 0 || "The value must be greater than zero",
      ],
      rules: [(v) => v.length > 0 || "This field is empty"],

      info_marker: null,
      infowindow: { lat: 39.9166685, lng: 116.383331 },
      window_open: false,
      map3: null,
      marker: [],
    };
  },
  mounted() {
    this.getList();
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 300);
      this.loader = null;
    },
  },
  computed: {},
  methods: {
    // onPickFile() {
    //   document.getElementById("fileUpload").click();
    // },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    lStage() {
      if (this.Health_status == "Live") {
        this.Life_stagess = ["Adult", "Juvenile", "Hatchling", "Nest or eggs"];
      } else {
        this.Life_stagess = [
          "Whole animal",
          "Shell",
          "Nest or eggs",
          "Callips",
        ];
      }
    },
    behaviourData() {
      if (this.Health_status == "Live") {
        this.behaviour = [
          "Basking",
          "Surfacing",
          "Nesting",
          "Mating",
          "Crawling",
        ];
      } else {
        this.behaviour = [" "];
      }
    },
    checkDate() {
      if (this.date > this.date1) {
        this.date = this.date1;
      }
    },

    openWindow() {
      this.window_open = true;
    },
    getList() {
      this.map3 = new google.maps.Map(document.getElementById("mapnew3"), {
        zoom: 5,
        center: { lat: 20.38, lng: 80.12 },
        // center: { lat: 9.528339, lng: 76.822503 },
        mapTypeId: "terrain",
      });
      google.maps.event.addListener(this.map3, "click", (e) => {
        this.mark(e);
      });
      this.marker = new google.maps.Marker({
        // position: { lat: this.latt, lng: this.lonn },
        map: this.map3,
        title: "Hello World!",
      });

      axios({
        method: "GET",
        url: "turtle/getlist",
      }).then((response) => {
        if (response.data.status) {
          this.speciesList = response.data.data;
        }
      });
    },

    //     setMapOnAll(map) {
    //   for (let i = 0; i < markers.length; i++) {
    //     markers[i].setMap(map);
    //   }
    // },
    mark(event) {
      // this.icons = "http://maps.google.com/mapfiles/ms/icons/red-dot.png";
      this.latt = 0;
      this.lonn = 0;
      this.marker.setMap(null);
      this.latt = event.latLng.lat();
      this.lonn = event.latLng.lng();
      // console.log("lat:", this.latt);
      // console.log("lng", this.lonn);

      this.marker = new google.maps.Marker({
        position: { lat: this.latt, lng: this.lonn },
        map: this.map3,
        title: "Hello World!",
      });
      //
    },
    browseImages(event) {
      this.selectedFiles = event.target.files[0];
      var outImage = "imagefondo";

      this.yesimg = true;
      var img;
      img = new Image();
      img.src = window.URL.createObjectURL(event.target.files[0]);
      img.onload = () => {
        const urls = URL.createObjectURL(this.selectedFiles);
        this.image = urls;

        document.getElementById(outImage).src = img.src; //replacing src for id:imagefondo
        this.cimage = this.$refs.imgg;
        this.cropper = new Cropper(this.cimage, {
          zoomable: false,
          scalable: false,
          aspectRatio: 1,
          crop: () => {
            const canvas = this.cropper.getCroppedCanvas();
            this.destination = canvas.toDataURL("image/png");
          },
        });
      };
    },

    blobToFile(theBlob, fileName) {
      //A Blob() is almost a File() - it's just missing the two properties below which we will add
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;
      return theBlob;
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    uploadCroppedImg() {
      this.loader = "loading4";
      var myBlob = new Blob();
      var myFile = this.blobToFile(myBlob, this.destination);
      console.log(myFile);
      var fileURL = this.dataURLtoFile(this.destination, myFile.name);
      console.log(fileURL);
      this.myblobb = fileURL;
      this.yesuploadedimg = true;
    },

    submitData() {
      if (this.$refs.form.validate()) {
        axios({
          method: "POST",
          url: "report/add",
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
          data: {
            createddate: this.date,
            state: this.state,
            nearestcity: this.city,
            turtle: this.species,
            numberofindividuals: this.no_of_individuals,
            lifestage: this.life_stage,
            type: this.type,
            habitat_found: this.habitat_found,
            Threats: this.threats,
            condition: this.Health_status,
            behaviour_observed: this.behaviour_observed,
            presence_of_nest: this.presence_of_nest,
            comment: this.comment,
            lat: this.latt,
            lon: this.lonn,
            purpose: "observation",
          },
        })
          .then((response) => {
            if (response.data.status) {
              this.uploadImages(response.data.data._id);
              this.formReset();
              this.resetValidation();
              alert("succesfully added");
              this.showsnackbar = true;
              this.snackmessage = "successfully uploaded";
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    uploadImages(item) {
      this.formData.append("image", this.myblobb);
      this.formData.append("id", item);
      axios({
        method: "POST",
        url: "report/imageupload",
        data: this.formData,

        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status == true) {
          alert("ok");
          this.formData = null;
        }
      });
    },
    removeImageArray() {
      this.image = null;
      this.yesimg = false;
      this.yesuploadedimg = false;
    },
    formReset() {
      this.habitat_health = "";
      this.life_stage = "";
      this.city = "";
      this.species = "";
      this.no_of_individuals = 0;
      this.city = "";
      this.type = "";
      this.comment = "";
      this.state = "";
      this.latt = 0;
      this.lonn = 0;
      this.presence_of_nest = "";
      this.behaviour_observed = "";
      this.habitat_found = "";
      this.Health_status = "";
      this.yesimg = false;
      this.image = null;
      this.yesuploadedimg = false;
    },
  },
};
</script>

<style>
#mapnew3 {
  height: 430px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>